<app-header class="app-header"></app-header>

<app-side-menu class="app-side-menu"></app-side-menu>
<main class="main"><router-outlet></router-outlet></main>

<app-footer class="app-footer"></app-footer>
